import React from "react";
// import Header from "./components/Header";
import Project from "./components/Project";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Project />
      <Footer />
    </>
  );
}

export default App;